// import React, { useEffect, useState } from "react";
// import {
//   Layout,
//   Card,
//   Form,
//   Input,
//   Select,
//   Upload,
//   Button,
//   Image,
//   message,
// } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../Config/index";
// import Sidebar from "../../Components/Sidebar";
// import SuccessPopup from "../../Components/popup/SuccessPopup";
// import ErrorPopup from "../../Components/popup/ErrorPopup";

// const { Content } = Layout;
// const { Option } = Select;

// const EditMakeVariation = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form] = Form.useForm();
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const [loading, setLoading] = useState(true);
//   const [btnLoading, setBtnLoading] = useState(false);

//   const [previewImage, setPreviewImage] = useState(null);
//   const [newImage, setNewImage] = useState(null);

//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   useEffect(() => {
//     fetchVariation();
//   }, []);

//   // Fetch variation by ID
//   const fetchVariation = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/makevariations/${id}`);

//       if (!res.data) {
//         message.error("Variation not found!");
//         return;
//       }

//       const v = res.data;

//       form.setFieldsValue({
//         variationName: v.variationName,
//         sanskrit: v.sanskrit,
//         exampleAsana: v.exampleAsana,
//         english: v.english,
//         variationType: v.variationType?.[0] || "",
//       });

//       setPreviewImage(v.variationImage);
//     } catch (error) {
//       console.log(error);
//       message.error("Failed to load variation");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Submit handler
//   const handleUpdate = async (values) => {
//     setBtnLoading(true);

//     const formData = new FormData();
//     formData.append("variationName", values.variationName);
//     formData.append("sanskrit", values.sanskrit);
//     formData.append("exampleAsana", values.exampleAsana);
//     formData.append("english", values.english);
//     formData.append("variationType", values.variationType);

//     if (newImage) {
//       formData.append("variationImage", newImage);
//     }

//     try {
//       const res = await axios.put(
//         `${BASE_URL}/makevariations/${id}`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       setSuccessPopup(true);

//       if (res.data.success) {
//         message.success("Variation updated successfully!");
//         form.resetFields();
//         setPreviewImage(null);
//         setNewImage(null);

//         navigate("/all-make-variations");
//       } else {
//         message.error(res.data.message || "Update failed");
//       }
//     } catch (error) {
//       console.log(error);
//       setErrorPopup(true);
//     } finally {
//       setBtnLoading(false);
//     }
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar collapsed={collapsed} role="admin" />

//       <Layout
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 80 : 200,
//           transition: "0.3s ease",
//         }}
//       >
//         <Content style={{ padding: 20 }}>
//           <Card
//             title="Edit Variation"
//             style={{ maxWidth: 750, margin: "0 auto" }}
//             loading={loading}
//           >
//             <Form form={form} layout="vertical" onFinish={handleUpdate}>
//               {/* Variation Name */}
//               <Form.Item
//                 label="Variation Name"
//                 name="variationName"
//                 rules={[
//                   { required: true, message: "Variation name is required" },
//                 ]}
//               >
//                 <Input />
//               </Form.Item>

//               {/* Sanskrit */}
//               <Form.Item
//                 label="Sanskrit Name"
//                 name="sanskrit"
//                 rules={[
//                   { required: true, message: "Sanskrit name is required" },
//                 ]}
//               >
//                 <Input />
//               </Form.Item>

//               {/* Example Asana */}
//               <Form.Item
//                 label="Example Asana"
//                 name="exampleAsana"
//                 rules={[
//                   { required: true, message: "Example asana is required" },
//                 ]}
//               >
//                 <Input />
//               </Form.Item>

//               {/* Variation Type */}
//               <Form.Item
//                 label="Variation Type"
//                 name="variationType"
//                 rules={[
//                   { required: true, message: "Please select variation type" },
//                 ]}
//               >
//                 <Select placeholder="Select variation type">
//                   <Option value="Hand variations">Hand variations</Option>
//                   <Option value="variations on legs">Variations on legs</Option>
//                   <Option value="other variations">Other variations</Option>
//                 </Select>
//               </Form.Item>

//               {/* English Description */}
//               <Form.Item
//                 label="English Description"
//                 name="english"
//                 rules={[
//                   { required: true, message: "English description required" },
//                 ]}
//               >
//                 <Input.TextArea rows={3} />
//               </Form.Item>

//               {/* Current Image */}
//               <Form.Item label="Current Image">
//                 <Image
//                   src={previewImage}
//                   width={200}
//                   style={{ borderRadius: 8 }}
//                 />
//               </Form.Item>

//               {/* Upload New Image */}
//               <Form.Item label="Change Image">
//                 <Upload
//                   beforeUpload={(file) => {
//                     setNewImage(file);

//                     const reader = new FileReader();
//                     reader.onload = (e) => setPreviewImage(e.target.result);
//                     reader.readAsDataURL(file);

//                     return false; // prevent auto-upload
//                   }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Upload New Image</Button>
//                 </Upload>
//               </Form.Item>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={btnLoading}
//                   disabled={btnLoading}
//                 >
//                   {btnLoading ? "Updating..." : "Update Variation"}
//                 </Button>
//               </Form.Item>
//               <SuccessPopup
//                 open={successPopup}
//                 onClose={() => setSuccessPopup(false)}
//                 message="Asana uploaded successfully!"
//               />

//               <ErrorPopup
//                 open={errorPopup}
//                 onClose={() => setErrorPopup(false)}
//                 message="Upload failed. Try again."
//               />
//             </Form>
//           </Card>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default EditMakeVariation;

import React, { useEffect, useState } from "react";
import {
  Layout,
  Card,
  Form,
  Input,
  Select,
  Upload,
  Button,
  Image,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Config/index";
import Sidebar from "../../Components/Sidebar";
import SuccessPopup from "../../Components/popup/SuccessPopup";
import ErrorPopup from "../../Components/popup/ErrorPopup";

const { Content } = Layout;
const { Option } = Select;

// ── Keep this list in sync with MakeVariations.js ────────────────────
const VARIATION_TYPES = [
  "Hand variations",
  "variations on legs",
  "other variations",
  // Add new subheadings here too
];

const EditMakeVariation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const [previewImage, setPreviewImage] = useState(null);
  const [newImage, setNewImage] = useState(null);

  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    fetchVariation();
  }, []);

  const fetchVariation = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/makevariations/${id}`);

      if (!res.data) {
        message.error("Variation not found!");
        return;
      }

      const v = res.data;

      form.setFieldsValue({
        variationName: v.variationName,
        asanaType: v.asanaType,
        sanskrit: v.sanskrit,
        exampleAsana: v.exampleAsana,
        english: v.english,
        variationType: v.variationType?.[0] || "",
      });

      setPreviewImage(v.variationImage);
    } catch (error) {
      console.log(error);
      message.error("Failed to load variation");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (values) => {
    setBtnLoading(true);

    const formData = new FormData();
    formData.append("variationName", values.variationName);
    formData.append("asanaType", values.asanaType);
    formData.append("sanskrit", values.sanskrit);
    formData.append("exampleAsana", values.exampleAsana);
    formData.append("english", values.english);
    formData.append("variationType", values.variationType);

    if (newImage) {
      formData.append("variationImage", newImage);
    }

    try {
      const res = await axios.put(
        `${BASE_URL}/makevariations/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setSuccessPopup(true);

      if (res.data.success || res.data.message === "Variation updated successfully") {
        message.success("Variation updated successfully!");
        navigate("/all-make-variations");
      } else {
        message.error(res.data.message || "Update failed");
      }
    } catch (error) {
      console.log(error);
      setErrorPopup(true);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} role="admin" />

      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 80 : 200,
          transition: "0.3s ease",
        }}
      >
        <Content style={{ padding: 20 }}>
          <Card
            title="Edit Variation"
            style={{ maxWidth: 750, margin: "0 auto" }}
            loading={loading}
          >
            <Form form={form} layout="vertical" onFinish={handleUpdate}>

              {/* Variation Type (Subheading) */}
              <Form.Item
                label="Variation Type (Subheading / Category)"
                name="variationType"
                rules={[
                  { required: true, message: "Please select variation type" },
                ]}
              >
                <Select placeholder="Select subheading category" showSearch>
                  {VARIATION_TYPES.map((type) => (
                    <Option key={type} value={type}>
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Variation Name */}
              <Form.Item
                label="Variation Name"
                name="variationName"
                rules={[
                  { required: true, message: "Variation name is required" },
                ]}
              >
                <Input />
              </Form.Item>

              {/* Asana Type */}
              <Form.Item
                label="Asana Type"
                name="asanaType"
                rules={[{ required: true, message: "Asana type is required" }]}
              >
                <Input />
              </Form.Item>

              {/* Sanskrit */}
              <Form.Item
                label="Sanskrit Name"
                name="sanskrit"
                rules={[
                  { required: true, message: "Sanskrit name is required" },
                ]}
              >
                <Input />
              </Form.Item>

              {/* Example Asana */}
              <Form.Item
                label="Example Asana"
                name="exampleAsana"
                rules={[
                  { required: true, message: "Example asana is required" },
                ]}
              >
                <Input />
              </Form.Item>

              {/* English Description */}
              <Form.Item
                label="English Description"
                name="english"
                rules={[
                  { required: true, message: "English description required" },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>

              {/* Current Image */}
              {previewImage && (
                <Form.Item label="Current Image">
                  <Image
                    src={previewImage}
                    width={200}
                    style={{ borderRadius: 8 }}
                  />
                </Form.Item>
              )}

              {/* Upload New Image */}
              <Form.Item label="Change Image">
                <Upload
                  beforeUpload={(file) => {
                    setNewImage(file);
                    const reader = new FileReader();
                    reader.onload = (e) => setPreviewImage(e.target.result);
                    reader.readAsDataURL(file);
                    return false;
                  }}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Upload New Image</Button>
                </Upload>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={btnLoading}
                  disabled={btnLoading}
                  size="large"
                  style={{ width: "100%" }}
                >
                  {btnLoading ? "Updating..." : "Update Variation"}
                </Button>
              </Form.Item>

              <SuccessPopup
                open={successPopup}
                onClose={() => setSuccessPopup(false)}
                message="Variation updated successfully!"
              />
              <ErrorPopup
                open={errorPopup}
                onClose={() => setErrorPopup(false)}
                message="Update failed. Try again."
              />
            </Form>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EditMakeVariation;